function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5a7a7d;stroke-linecap:round;stroke-linejoin:round;stroke-width:50px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M566.81,374.84l12.32,8a59.24,59.24,0,0,1,17.57,81.66L477.4,649.1a59.23,59.23,0,0,1-81.62,17.54l-12.35-8A59.23,59.23,0,0,1,365.89,577L485.17,392.41A59.23,59.23,0,0,1,566.81,374.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M678.39,446.93l12.33,8a59.24,59.24,0,0,1,17.56,81.64L589,721.17a59.21,59.21,0,0,1-81.65,17.54L495,730.77a59.2,59.2,0,0,1-17.55-81.64L596.78,464.49A59.2,59.2,0,0,1,678.39,446.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M207.8,531.38l.79-438.84A67.72,67.72,0,0,1,276.11,25h14.22a67.71,67.71,0,0,1,67.51,67.54V344.85"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M455.3,302.81l12.3,7.94a59.23,59.23,0,0,1,17.58,81.66L392.6,535.69A59.19,59.19,0,0,1,311,553.26l-12.33-8a59.22,59.22,0,0,1-17.54-81.64l92.57-143.3A59.21,59.21,0,0,1,455.3,302.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M383.13,932.42C370.79,809.61,206.65,755,206.65,755l-13.56-57.08L270.75,644c30.51-24.73,34.28-66.44,14-102.78-15.93-28.43-48.89-17-48.89-17S90.34,559.92,58.9,580.61C-8.59,625,41,794.22,68.36,846S173,1057.2,173,1057.2L189.81,1133"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "715.43 520.75 697.12 828.71 592.87 1057.18"
})));

function SvgLeft1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 742.66 1157.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft1);
export default __webpack_public_path__ + "static/media/left-1.8c2de034.svg";
export { ForwardRef as ReactComponent };